const state = {
  isCallingApi: false,
  isCallingListStaffAcastApi: false,
  isCallingListMessageAcastApi: false,
  hasCallingTabs: false,
  hasModalNetworkError: false,
  hasModalLogOff: false
}

const getters = {
  isCallingApi (state) {
    return state.isCallingApi
  },
  isCallingListStaffAcastApi (state) {
    return state.isCallingListStaffAcastApi
  },
  isCallingListMessageAcastApi (state) {
    return state.isCallingListMessageAcastApi
  },
  hasCallingTabs(state) {
    return state.hasCallingTabs
  },
  getHasModalNetworkError(state) {
    return state.hasModalNetworkError
  },
  getHasModalLogOff(state) {
    return state.hasModalLogOff
  }
}

const mutations = {
  SET_IS_CALLING_API (state, payload) {
    state.isCallingApi = payload
  },
  SET_IS_CALLING_LIST_STAFF_ACAST_API (state, payload) {
    state.isCallingListStaffAcastApi = payload
  },
  SET_IS_CALLING_LIST_MESSAGE_ACAST_API (state, payload) {
    state.isCallingListMessageAcastApi = payload
  },
  SET_HAS_CALLING_TABS(state, payload) {
    state.hasCallingTabs = payload
  },
  SET_HAS_MODAL_NETWORK_ERROR(state, payload) {
    state.hasModalNetworkError = payload
  },
  SET_HAS_MODAL_LOG_OFF(state, payload) {
    state.hasModalLogOff = payload
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
